export function computeStats({ teams, jobs, assignments }) {
  const jobById = Object.fromEntries(jobs.map((j) => [j.id, j]));
  const valid = assignments.filter((a) => jobById[a.job_id]);
  const count = (s) => valid.filter((a) => a.status === s).length;
  const total = valid.length;
  const done = count("done");

  const perTeam = teams.map((t) => {
    const items = valid
      .filter((a) => a.team_id === t.id)
      .map((a) => ({ ...a, job: jobById[a.job_id] }))
      .sort((a, b) => a.job.no - b.job.no);
    const doneItems = items.filter((i) => i.status === "done");
    const pointsDone = doneItems.reduce((s, i) => s + i.job.weight, 0);
    const target = items.reduce((s, i) => s + i.job.weight, 0);
    const remaining = target - pointsDone;
    const pct = target ? (pointsDone / target) * 100 : 0;
    return { team: t, items, doneCount: doneItems.length, pointsDone, target, remaining, pct, verdict: verdict(pct, items) };
  });

  const totalPoints = perTeam.reduce((s, p) => s + p.target, 0);
  const donePoints = perTeam.reduce((s, p) => s + p.pointsDone, 0);
  return {
    total, done, inProgress: count("in_progress"), notStarted: count("not_started"),
    totalPoints, donePoints, perTeam,
    overallPct: totalPoints ? (donePoints / totalPoints) * 100 : 0,
  };
}

function verdict(pct, items) {
  if (!items.length) return "No Assignment";
  if (pct >= 100) return "Completed";
  if (pct >= 70) return "Excellent";
  if (pct >= 40) return "On Track";
  if (pct > 0) return "Needs Attention";
  return items.some((i) => i.status === "in_progress") ? "Started" : "No Progress Yet";
}

export function analystConclusion(stats) {
  const { perTeam, totalPoints, donePoints } = stats;
  const active = perTeam.filter((p) => p.items.length);
  if (!active.length) return "No jobs have been assigned to any team yet.";
  const heaviest = [...active].sort((a, b) => b.remaining - a.remaining)[0];
  const heavyJobs = heaviest.items.filter((i) => i.status !== "done" && i.job.weight >= 3).map((i) => i.job.name);
  const riskText = heavyJobs.length
    ? `, including ${heavyJobs.join(", ")} (weight 3) which are high-risk and weather-dependent, so weather windows and safety support should be prioritised`
    : "";
  if (donePoints === 0) {
    return `No team has completed any work yet; the entire workload (${totalPoints} points) is still open. ${heaviest.team.name} carries the heaviest remaining workload at ${heaviest.remaining} points${riskText}.`;
  }
  const best = [...active].sort((a, b) => b.pct - a.pct || b.pointsDone - a.pointsDone)[0];
  const open = totalPoints - donePoints;
  if (open === 0) return `All work is complete (${totalPoints} / ${totalPoints} points). ${best.team.name} led with ${best.pointsDone} points delivered.`;
  return `${donePoints} of ${totalPoints} points completed (${((donePoints / totalPoints) * 100).toFixed(1)}%). Most productive team: ${best.team.name} at ${best.pct.toFixed(1)}% (${best.pointsDone}/${best.target} pts). Heaviest remaining workload: ${heaviest.team.name} with ${heaviest.remaining} points open${riskText}.`;
}
